import { Component, Input, OnChanges, OnInit } from '@angular/core';


@Component({
  selector: 'app-pos-qr-code',
  templateUrl: './pos-qr-code.component.html',
  styleUrls: ['./pos-qr-code.component.sass']
})
export class PosQrCodeComponent implements OnInit, OnChanges {

  @Input()
  value: string = "";

  @Input()
  encode: boolean = false;
  QRUrl: string = "";
  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    if (this.value) {
      const encodedValue = this.encode ? encodeURIComponent(this.value) : this.value;
      //this.QRUrl = `https://chart.googleapis.com/chart?cht=qr&chl=${encodedValue}&chs=280x280&chld=L|0`;
      this.QRUrl = `https://api.qrserver.com/v1/create-qr-code/?size=280x280&data=${encodedValue}`;
    }
  }

}
